import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import WarningIcon from '@mui/icons-material/Warning';
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';

export default function WarningDialog({
  title,
  content,
  loading,
  open,
  onCancel,
  onConfirm,
  checkboxLabel,
  checkboxChecked,
  onCheckboxChange,
}) {
  const { t } = useTranslation();

  return (
    <Dialog open={open}>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <WarningIcon sx={{ marginRight: 1 }} />
          {title}
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
        {checkboxLabel && (
          <Box mt={2} display="flex" alignItems="center">
            <Checkbox checked={checkboxChecked} onChange={onCheckboxChange} />
            {checkboxLabel}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        {onCancel && (
          <Button autoFocus variant="outlined" onClick={onCancel}>
            {t('Cancel')}
          </Button>
        )}
        {onConfirm && (
          <Button disabled={loading} onClick={onConfirm} variant="contained">
            {t('Continue')}
            {loading && <CircularProgress size={24} sx={{ ml: 1, color: 'white' }} />}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
